import DefaultLayout from './Default'
import OnboardingLayout from './Onboarding'

export { DefaultLayout, OnboardingLayout }
